import angular from 'angular';

import _css from './od-buyer-faqs.less';

module.exports = angular.module('market.components.od-buyer-faqs', [
])
.component('odBuyerFaqs', {
  template: require('./od-buyer-faqs.jade')()
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-buyer-faqs.js
 **/